module.exports = __webpack_public_path__ + "media/02.41f697ba.mp3";